import { lazy, ReactNode, Suspense } from 'react'
import { useAuth } from './auth/AuthContext'
import { AppLayout } from './components/AppLayout'
import { PageLoader } from './components/PageLoader'
import { LandingPage } from './pages/LandingPage'
import { LoginPage } from './pages/LoginPage'
import { Navigate, usePathname } from './routing/Router'

const DashboardPage = lazy(() => import('./pages/DashboardPage'))
const PropertiesPage = lazy(() => import('./pages/PropertiesPage'))
const ProvidersPage = lazy(() => import('./pages/ProvidersPage'))
const ReceiptsPage = lazy(() => import('./pages/ReceiptsPage'))
const MetersPage = lazy(() => import('./pages/MetersPage'))
const FamilyPage = lazy(() => import('./pages/FamilyPage'))
const PaymentsPage = lazy(() => import('./pages/PaymentsPage'))
const SettingsPage = lazy(() => import('./pages/SettingsPage'))

function ProtectedApp({ children }: { children: ReactNode }) {
  const { loading, user } = useAuth()
  if (loading) return <PageLoader label="Загружаем кабинет" />
  if (!user) return <Navigate to="/login" replace />
  return <AppLayout>{children}</AppLayout>
}

export function App() {
  const pathname = usePathname()
  let page: ReactNode

  if (pathname === '/') page = <LandingPage />
  else if (pathname === '/login') page = <LoginPage />
  else if (pathname === '/app') page = <ProtectedApp><DashboardPage /></ProtectedApp>
  else if (pathname === '/app/objects') page = <ProtectedApp><PropertiesPage /></ProtectedApp>
  else if (pathname === '/app/providers') page = <ProtectedApp><ProvidersPage /></ProtectedApp>
  else if (pathname === '/app/receipts') page = <ProtectedApp><ReceiptsPage /></ProtectedApp>
  else if (pathname === '/app/meters') page = <ProtectedApp><MetersPage /></ProtectedApp>
  else if (pathname === '/app/family') page = <ProtectedApp><FamilyPage /></ProtectedApp>
  else if (pathname === '/app/payments') page = <ProtectedApp><PaymentsPage /></ProtectedApp>
  else if (pathname === '/app/settings') page = <ProtectedApp><SettingsPage /></ProtectedApp>
  else page = <Navigate to="/" replace />

  return (
    <Suspense fallback={<PageLoader label="Загружаем раздел" />}>
      {page}
    </Suspense>
  )
}
